<template>
    <div>
        <!--middle middle section-->
        <div class="main-internal-section width-full float-l">
            <div class="container">
                <template v-if="cantAccessPage === true">
                    <div class="row">

                        <div class="chat-btm-section-main chat-btm-user-section width-full float-l" v-if="userDetails && userDetails != ''"> <!--middle section-->

                            <div class="top-user-detail-section col-12 float-l">
                                <p class="chat-user-name-detail font-benton-bold heading-text-54 radius-100 bgcolor-71c1c5 bold relative color-white"> {{userDetails.email | filtersGetName(userDetails.name)}} 
                                    <span class="edit-icon absolute"> <a href="#"> <i class="hi-icon icon-chatpencil"> </i> </a> </span>
                                </p>
                                
                                <h2 class="username-detail center heading-text-18 line-height-22 color-333333 font-benton-bold width-full ucase pt_25"> {{userDetails.name}} </h2> 
                            </div>

                            <div class="site-list-section col-12 float-l relative pt_20 pb_20 border-top-e8e9ea">
                                <span class="bgcolor-9abfd1 radius-100 absolute p_5 float-l l-20 t-25"> </span>

                                <div class="right-site-list-section float-l width-full pl_35">
                                    <h5 class="float-l width-full heading-text-16 line-height-20 color-333333 font-benton-bold mb_5"> Email </h5>
                                    <span class="color-888888 float-l width-full font-benton-book heading-text-14 line-height-18"> {{userDetails.email}} </span>
                                </div>
                            </div>

                            <div class="site-list-section col-12 float-l relative pt_20 pb_20 border-top-e8e9ea">
                                <span class="bgcolor-9abfd1 radius-100 absolute p_5 float-l l-20 t-25"> </span>

                                <div class="right-site-list-section float-l width-full pl_35">
                                    <h5 class="float-l width-full heading-text-16 line-height-20 color-333333 font-benton-bold mb_5"> Timezone</h5>
                                    <span class="color-888888 float-l width-full font-benton-book heading-text-14 line-height-18"> {{userDetails.tzName}} </span>
                                </div>
                            </div>

                            <div class="site-list-section col-12 float-l relative pt_20 pb_20 border-top-e8e9ea">
                                <span class="bgcolor-9abfd1 radius-100 absolute p_5 float-l l-20 t-25"> </span>
                                <div class="right-site-list-section float-l width-full pl_35">
                                    <h5 class="float-l width-full heading-text-16 line-height-20 color-333333 font-benton-bold mb_5"> Section </h5>
                                    <ul>
                                        <li class="float-l width-full color-888888 float-l width-full font-benton-book heading-text-14 line-height-18"> {{userDetails.sections | filterUSting}}  ({{userDetails.role | filterUSting}})</li>
                                    </ul>
                                </div>
                            </div>

                        </div> <!--middle section-->	  
                    </div>
                </template>
                <template v-else>
                    <template v-if="isRequestComplete">
                        <div class="col-md-12">
                            <div class="error-template">
                                <h1>
                                    Oops!</h1>
                                <h2>
                                    403 </h2>
                                <div class="error-details">
                                    Sorry!, You don't have permission to access this page.
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div> 
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import moment from 'moment';
    import EventBus from '../event-bus';

    Vue.component("app-footer", Footer);
    export default {
        name: 'UserDetail',
        mixins: [commonMixins],
        data () {
            return {
                cantAccessPage: true,
                isRequestComplete: false,
                userDetails: [],
            }
        },
        mounted: function() {
            var self = this;
            self.loadUserDetails();
            EventBus.$emit("headerMobileView", 'User Detail');
            self.getPermissions();
        },
        filters: {
            filtersGetName(value, value2) {

                let name1 = value2.split(" ");
                if(name1[1] && name1[1] != '') {
                    let getName = name1[0].charAt(0) + name1[1].charAt(0);
                    return getName.toUpperCase();
                }
                if(value) {
                    let name = value.charAt(0);
                    let splitData = value.split("@");
                    name += splitData[1].charAt(0);
                    return name.toUpperCase();
                }
            },
            filterUSting(data) {

                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            }
        },
        methods: {
            loadUserDetails: function() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                var fields = {
                    'user_id': segments[3]
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                self.showLoader();
                HTTP.post("get-user-by-id", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {

                            if (response.data.content != "") {
                                self.userDetails = response.data.content;
                            }
                        }
                        self.hideLoader();
                    })
                    .catch(function (error) {
                        self.hideLoader();
                        self.catchHandler(error, function () {});
                    });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/components/Users/UserDetail.vue